var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.remoteData === null || _vm.remoteDataPending)?_c('v-progress-circular',{class:_vm.clazz,attrs:{"color":_vm.color,"indeterminate":""}},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }